module.exports = __webpack_public_path__ + "static/trumpet-logo-d96c0fdaf2115a000e7d91f553edf00c.png";